import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import Venster from '../Venster.jsx';

export default function Guestbook({ v }) {
  if (!v.showGuestbook) return null;
  return (
    <Venster v={v} venster={v.gbVenster} titel="Het gastenboek" onSluit={v.closeGuestbook}>
      <div style={css(v.gbPanelStyle)}>
          {' '}
          <div style={css(v.gbSubStyle)}>
            <Interp v={v.gbSubLine} />
          </div>
          {' '}
          <div style={css(v.gbWrapStyle)}>
            {' '}
            <div onClick={v.gbClick} onMouseEnter={v.gbHoverEnter} onMouseMove={v.gbHoverMove} onMouseLeave={v.gbHoverOut} style={css(v.gbBoardStyle)} />
            {' '}
            {v.showGbTip ? (<>
              {' '}
              <div style={css(v.gbTipStyle)}>
                {' '}
                <img alt="" src={v.gbTipAvatar} style={{ "width": "20px", "height": "20px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                {' '}
                <span>
                  {"pixel geplaatst door "}
                  <span style={{ "fontWeight": "700" }}>
                    <Interp v={v.gbTipName} />
                  </span>
                </span>
                {' '}
              </div>
              {' '}
            </>) : null}
            {' '}
          </div>
          {' '}
          <div style={css(v.gbRijStyle)}>
            {toList(v.gbSwatches).map((s, $index) => (
              <React.Fragment key={$index}>
                <button onClick={s?.onPick} title={s?.title} className="gp-btn" style={css(s?.style)} />
              </React.Fragment>
            ))}
            <button onClick={v.gbPickEraser} title="Pixels weghalen" className="gp-btn" style={css(v.gbEraserStyle)}>
              {' '}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.9" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                <path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21" />
                <path d="M22 21H7" />
              </svg>
              {' '}
            </button>
            <button onClick={v.undoGbPixel} title="Laatste pixel terugnemen" className="gp-btn" disabled={v.gbNoUndo} style={css(v.gbUndoStyle)}>
              {' '}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.9" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                <path d="M9 14 4 9l5-5" />
                <path d="M4 9h10a6 6 0 0 1 0 12h-3" />
              </svg>
              {' '}
            </button>
          </div>
          {' '}
          {v.showGbMissing ? (<>
            {' '}
            <div style={{ "fontSize": "12px", "fontWeight": "600", "color": "var(--fout)", "lineHeight": "1.4" }}>
              <Interp v={v.gbMissingHint} />
            </div>
            {' '}
          </>) : null}
          {' '}
          <div style={css(v.gbKlaarStyle)}>
            <button onClick={v.closeGuestbook} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
              Klaar
            </button>
          </div>
          {' '}
      </div>
    </Venster>
  );
}
